import { createSlice } from '@reduxjs/toolkit';

export const resetSlice = createSlice({
  name: 'reset',
  initialState: {},
  reducers: {
    resetState: () => ({}), // Acción para reiniciar el estado
  },
});

export const { resetState } = resetSlice.actions;